import React, { forwardRef } from "react";

import { CheckboxProps } from "./Checkbox.types";
import {
    CheckboxInput,
    CheckboxInputLabel,
    CheckboxWrapper,
} from "./Checkbox.styles";
import COLORS from "../../constants/colors";

const Checkbox = forwardRef<HTMLDivElement, CheckboxProps>(
    (props: CheckboxProps, ref) => {
        const {
            id = `radio-${props.name}-${props.index}`,
            fillColor = COLORS.BLUE,
            label,
            name,
            value,
            disabled,
            index,
            onChange,
            checkboxWrapperClass,
            checkBoxClass,
            checkBoxLabelClass,
            size = "sm",
            alignItems = "flex-start",
            labelProps,
        } = props;

        return (
            <CheckboxWrapper
                className={checkboxWrapperClass}
                alignItems={alignItems}
            >
                <CheckboxInput
                    type="checkbox"
                    id={id}
                    checked={value}
                    disabled={disabled}
                    name={name}
                    onChange={onChange}
                    // SC Props
                    fillColor={fillColor}
                    className={checkBoxClass}
                    size={size}
                />
                <CheckboxInputLabel
                    {...labelProps}
                    className={checkBoxLabelClass}
                    htmlFor={id}
                >
                    {label}
                </CheckboxInputLabel>
            </CheckboxWrapper>
        );
    },
);

export default Checkbox;
